


import Callback from "./views/Callback";
import Connect from "./views/Connect";
import DefaultConfig from "./views/DefaultConfig";
import Fora from "./views/Fora";
import Home from "./views/Home";
import Signup from "./views/Signup";
import Signin from "./views/Signin";
import Signout from "./views/Signout";
import Mapping from "./views/Mapping";
import Job from "./views/Jobs";
import JobDesktop from "./views/JobsDesktop";
import JobCsv from "./views/JobsCsv";
import Logs from "./views/Logs";
import TestAccount from "./views/TestAccount";
import QBD from "./views/QBD";
import Disconnect from "./views/Disconnect";
import LearnMore from "./views/LearnMore";
import LearnMoreQuickBooksOnline from "./views/LearnMore/QuickBooksOnline";
import LearnMoreQuickBooksDesktop from "./views/LearnMore/QuickBooksDesktop";
import LearnMoreCsv from "./views/LearnMore/Csv";
import NotFound from "./views/NotFound";
const AppRoutes = [
  {
    index: true,
    element: <Home />
  },
  {
    path: '/callback',
    element: <Callback />
  },
  {
    path: '/connect',
    element: <Connect />,
    requiresAuth: true
  },
  {
    path: '/account',
    element: <Fora />
  },
  {
    path: '/test',
    element: <TestAccount />,
    requiresAuth: true
  },
  {
    path: '/signin',
    element: <Signin />
  },
  {
    path: '/learn-more',
    element: <LearnMore />
  },
  {
    path: '/learn-more/quickbooks-online',
    element: <LearnMoreQuickBooksOnline />
  },
  {
    path: '/learn-more/quickbooks-desktop',
    element: <LearnMoreQuickBooksDesktop />
  },
  {
    path: '/learn-more/csv',
    element: <LearnMoreCsv />
  },
  {
    path: '/signout',
    element: <Signout />
  },
  {
    path: '/mapping',
    element: <Mapping />,
    requiresAuth: true
  },
  {
    path: '/jobs',
    element: <Job />,
    requiresAuth: true
  },
  {
    path: '/jobs/desktop',
    element: <JobDesktop />,
    requiresAuth: true
  },
  {
    path: '/jobs/csv',
    element: <JobCsv />,
    requiresAuth: true
  },
  {
    path: '/logs',
    element: <Logs />,
    requiresAuth: true
  },
  {
    path: '/default',
    element: <DefaultConfig />,
    requiresAuth: true
  },
  {
    path: '/disconnect',
    element: <Disconnect />,
    requiresAuth: true
  },
  {
    path: '/qbd',
    element: <QBD />,
    requiresAuth: true
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default AppRoutes;
